<template>
  <div>

    <search-nav @handleSearch="handleSearch">
      <search-nav-item-date label="대상기간" v-model="nav.date" />
      <search-nav-item-keyword label="키워드" v-model="nav.keyword" />
    </search-nav>

    <vs-row class="mb-4">
      <vs-col class="flex" vs-justify="flex-end">
        <vs-button class="mr-2" type="border" color="secondary" @click="excelDownFunc">{{$t('button.Excel 다운로드')}}</vs-button>
        <vs-button class="mr-2" type="border" color="secondary" @click="handleClickApprovalLine">{{$t('button.결재선 지정')}}</vs-button>
        <vs-button color="secondary" @click="handleClickRegister">신규작성</vs-button>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col>
        <vs-table stripe
                  ref="table"
                  :sst="true"
                  :max-items="table.perPage"
                  :data="table.list"
                  noDataText="'대상기간' 을 선택하거나, 키워드 검색을 진행하여 주세요."
                  @sort="handleSort"
                  @selected="handleItemClickDetail"
        >

          <template slot="thead">
            <vs-th sort-key="id"><vs-col vs-type="flex" vs-justify="center">No.</vs-col></vs-th>
            <vs-th sort-key="content$preview.title"><vs-col vs-type="flex" vs-justify="center">사무소명</vs-col></vs-th>
            <vs-th sort-key="content$preview.processType"><vs-col vs-type="flex" vs-justify="center">공정명</vs-col></vs-th>
            <vs-th sort-key="created_at"><vs-col vs-type="flex" vs-justify="center">대상기간</vs-col></vs-th>
            <vs-th sort-key="created_at"><vs-col vs-type="flex" vs-justify="center">작성일</vs-col></vs-th>
            <vs-th sort-key="content$preview.writer"><vs-col vs-type="flex" vs-justify="center">작성자</vs-col></vs-th>
            <vs-th sort-key="status"><vs-col vs-type="flex" vs-justify="center">결재상태</vs-col></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="text-center">{{ getNo(indextr) }}</vs-td>
              <vs-td class="text-center">{{ tr.post_title }}</vs-td>
              <vs-td class="text-center">{{ getContent(tr).baseInfo.대상공종 }}</vs-td>
              <vs-td class="text-center">{{ `${getContent(tr).baseInfo.대상시작일} ~ ${getContent(tr).baseInfo.대상종료일}` }}</vs-td>
              <vs-td class="text-center">{{ tr.created_at }}</vs-td>
              <vs-td class="text-center">{{ tr.user.name }}</vs-td>
              <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>

            </vs-tr>
          </template>
        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination
              :total="(lastPage) ? lastPage : 1"
              v-model="currentPage" @change="handleChangePage"></k-pagination>
          </div>
        </div>

      </vs-col>
    </vs-row>

    <popup-approval-process
      v-model="approvalLine"
      :show-popup="showApprovalLinePopup"
      @closePopup="handleCloseApprovalPopup"/>

    <popup-excel-download
      v-model="showExcelDownload"
      :list="excelList"
      title="정기 위험성평가"/>
  </div>
</template>

<script>
import PopupExcelDownload from '@/views/components/popup/PopupExcelDownload'
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name: 'RiskAssessmentList',
  components: {
    KPagination,
    PopupApprovalProcess,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav,
    PopupExcelDownload
  },
  props: {
    boardId: Number,
    boardSlug: String,
    tagKey: String
  },
  data () {
    return {
      // 검색 네비게이션
      nav: {
        date: ['', ''],
        keyword: '',
        orderTarget:'created_at',
        orderDirection:'desc'
      },

      // approvalLine
      approvalLine: [],
      showApprovalLinePopup: false,
      showExcelDownload: false,
      listAll: [],

      currentPage: 1,
      lastPage: 1,
      total: 0,

      rootPath: '', // 프로젝트의 rootPath
      postId: '',
      table: {
        list: [],
        perPage: 10,
        keyword: ''
      }
    }
  },

  computed: {
    excelList () {
      const list = []
      for (const data of this.listAll) {
        list.push({
          사무소명: data.post_title,
          대상공종: this.getContent(data).baseInfo.대상공종,
          대상기간: `${this.getContent(data).baseInfo.대상시작일} ~ ${this.getContent(data).baseInfo.대상종료일}`,
          작성일: data.created_at,
          작성자: data.user.name,
          결재상태: data.document_status.name
        })
      }

      return list
    }
  },

  created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}`
    this.loadPostList()
  },
  methods: {

    getNo (index) {
      return this.total - (((this.currentPage - 1) * this.table.perPage) + index)
    },
    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug // first_risk(id:6)
      const page = this.currentPage
      const perPage = this.table.perPage
      const keyword = []
      const periodTargetBegin = 'preview.begin_ymd'
      const periodTargetEnd = 'preview.end_ymd'
      const periodDateBegin = this.nav.date[0]
      const periodDateEnd = this.nav.date[1]
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection

      if (this.nav.keyword) {
        keyword.push(this.nav.keyword)
      }

      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        projectId,
        boardSlug,
        page,
        perPage,
        keyword,
        periodTargetBegin, periodTargetEnd, periodDateBegin, periodDateEnd,
        orderTarget, orderDirection
      })

      this.table.list = this.$store.state.approval.list
      console.log(this.table.list)
      const listInfo = this.$store.state.approval.postListInfo

      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page
      this.total = listInfo.total

    },

    async loadPostListAll () {
      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const page = 1
      const perPage = 10000
      const keyword = this.nav.keyword
      const periodTargetBegin = 'preview.begin_ymd'
      const periodTargetEnd = 'preview.end_ymd'
      const periodDateBegin = this.nav.date[0]
      const periodDateEnd = this.nav.date[1]
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection
      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        projectId,
        boardSlug,
        page,
        perPage,
        keyword,
        periodTargetBegin, periodTargetEnd, periodDateBegin, periodDateEnd,
        orderTarget,
        orderDirection
      })
      this.listAll = JSON.parse(JSON.stringify(this.$store.state.approval.list))
      await this.loadPostList()
    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content
      }
    },

    async excelDownFunc () {
      await this.loadPostListAll()
      this.showExcelDownload = true
    },
    handleClickApprovalLine () {
      this.showApprovalLinePopup = true
    },
    handleCloseApprovalPopup () {
      this.showApprovalLinePopup = false
    },

    handleSearch () {
      this.currentPage = 1
      this.loadPostList()
    },

    handleClickRegister () {
      this.$emit('handleClickRegister', this.tagKey)
    },

    handleItemClickDetail (data) {
      this.$router.push({path: `${this.rootPath}/risk/assessment/${this.tagKey}/${data.post_id}`})
    },

    handleSort (key, type) {
      if (key) {
        this.nav.orderTarget = key
        this.nav.orderDirection = type
        this.loadPostList()
      }

    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    }
  }
}
</script>

<style scoped>

</style>
